<template>
    <div class="order-result private">
        <div class="order-result-block-1 private">
            <div class="order-result-block-1__col">
                <div class="order-result-block-1__text-container text-container">
                    <h2 class="order-section__heading">4. Lieferung</h2>
                </div>

                <edit-private v-if="subscriptionType" />

                <!-- summary block -->
                <div class="order-result-block-1__link-container private">
                    <a
                        href="#"
                        @click.prevent="togglePriceSummaryModalVisible"
                        class="order-result-block-1__link-info"
                    >
                        Preiszusammenstellung
                    </a>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import EditPrivate from './EditPrivate.vue';

export default {
    components: {
        EditPrivate,
    },
    computed: {
        ...mapState({
            subscriptionType: state => state.subscriptionType,
        }),
    },
    methods: {
        togglePriceSummaryModalVisible() {
            this.$store.commit('togglePriceSummaryModalVisible');
        },
    },
};
</script>



// WEBPACK FOOTER //
// ResultsPrivate.vue?29269374